import axios from "axios";
export default axios.create({
  baseURL: "https://missionorganicmizoram.com/",
  // baseURL: "http://192.168.0.15:5000/",
});
